import React from 'react';
import {
  Box,
  Button,
  Modal,
  Fade,
  Backdrop,
  Typography
} from '@mui/material';
import ExportResults from './ExportResults';

interface ExportResultsModalProps {
  open: boolean;
  onClose: () => void;
  exportedConfig: any;
  exportError: string | null;
  exportResult: boolean;
  onCopyConfig: () => void;
}

const ExportResultsModal: React.FC<ExportResultsModalProps> = ({
  open,
  onClose,
  exportedConfig,
  exportError,
  exportResult,
  onCopyConfig
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1,
          maxHeight: '90vh',
          overflow: 'auto'
        }}>           
          
          {exportedConfig && (
            <ExportResults 
              exportedConfig={exportedConfig}
              exportError={exportError}
              exportResult={exportResult}
              onCopyConfig={onCopyConfig}
            />
          )}
          
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button onClick={onClose} variant="contained">Close</Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ExportResultsModal;
